import React, { PureComponent } from 'react';
import { Title, Text, Wrapper } from './styled';

class TextBlock extends PureComponent {
    render() {
        return (
            <Wrapper>
                <Title>Цифровое телевидение и интернет в частный дом</Title>
                <Text>Забудьте про низкое качество связи и крошечный набор каналов за городом или в области. Пользуйтесь быстрым интернетом и смотрите любимые каналы даже если вы на даче.</Text>
            </Wrapper>
        );
    }
}

export default TextBlock;
